module.exports = __webpack_public_path__ + "media/images/sales/early/heading-problem-data-9335d68c34a4067c88e551a30acb13ef.svg";